<mat-chip-set aria-label="Time selection" class="chip-set">
    <mat-chip *ngFor="let chip of chipDurations"
        [ngStyle]="{'background-color': duration === chip.time ? 'lightblue' : ''}"
        (click)="selectTime(chip.time)" matTooltip={{chip.toolTip}}>
        {{chip.text}}
    </mat-chip>
</mat-chip-set>